<template>
	<div class="calculator__switch">
		<div class="mdc-switch ln-switch">
			<div class="mdc-switch__track"></div>
			<div class="mdc-switch__thumb-underlay">
				<div class="mdc-switch__thumb">
					<input
						:id="id"
						class="mdc-switch__native-control"
						:name="id"
						role="switch"
						type="checkbox"
						:checked="checked"
					/>
				</div>
			</div>
		</div>
		<label :for="id" :aria-label="ariaLabel">
			{{ label }}
		</label>
	</div>
</template>

<script>
export default {
	name: 'InputSwitch',
	props: {
		id: String,
		label: String,
		ariaLabel: String,
		checked: Boolean
	},
	mounted() {
		if (window.LN && window.LN.initCustomFields) {
			window.LN.initCustomFields(this.$el);
		}
	}
};
</script>

<style>
@import url('../assets/css/variables.css');

.calculator__switch {
}
</style>
